/* Separate page launch: no cohort, cart-provider selection or page-widget suppression. */
(function(){'use strict';document.addEventListener('byob:added',function(){var r=window.Rebuy;if(r&&r.Cart&&r.SmartCart)r.Cart.fetchShopifyCart(function(){r.SmartCart.show();});});})();
